import { render } from "./Ghe.vue?vue&type=template&id=15fed5b0"
import script from "./Ghe.vue?vue&type=script&lang=js"
export * from "./Ghe.vue?vue&type=script&lang=js"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
